<div class="top-up-container">
  <div class="top-up-header">
    <h2>Top Up Balance</h2>
    <p>Add funds to your account balance</p>
  </div>

  <div class="alert-container" *ngIf="successMessage || errorMessage">
    <div class="alert success" *ngIf="successMessage">
      {{ successMessage }}
      <button class="alert-close" (click)="successMessage = ''">×</button>
    </div>
    <div class="alert error" *ngIf="errorMessage">
      {{ errorMessage }}
      <button class="alert-close" (click)="errorMessage = ''">×</button>
    </div>
  </div>

  <form [formGroup]="topUpForm" (ngSubmit)="onSubmit()" class="top-up-form">
    <div class="form-group">
      <label for="amount">Amount (USD)</label>
      <div class="input-wrapper">
        <span class="currency-symbol">$</span>
        <input
          type="number"
          id="amount"
          formControlName="amount"
          placeholder="0.00"
          step="0.01"
          min="0.01"
          class="form-control"
          [class.invalid]="
            topUpForm.get('amount')?.invalid && topUpForm.get('amount')?.touched
          "
        />
      </div>
      <div
        class="error-message"
        *ngIf="
          topUpForm.get('amount')?.invalid && topUpForm.get('amount')?.touched
        "
      >
        <div *ngIf="topUpForm.get('amount')?.errors?.['required']">
          Amount is required
        </div>
        <div *ngIf="topUpForm.get('amount')?.errors?.['min']">
          Amount must be at least $0.01
        </div>
      </div>
    </div>

    <div class="form-group">
      <label for="paymentMethod">Payment Method</label>
      <input type="hidden" id="paymentMethod" formControlName="paymentMethod" />
      <div class="payment-methods">
        <div
          *ngFor="let method of paymentMethods"
          class="payment-method-option"
          [class.selected]="topUpForm.get('paymentMethod')?.value === method.id"
          (click)="topUpForm.get('paymentMethod')?.setValue(method.id)"
        >
          <div class="method-icon" [ngClass]="method.id">
            <svg *ngIf="method.id === 'card'" viewBox="0 0 24 24">
              <path
                d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
              ></path>
            </svg>

            <svg *ngIf="method.id === 'bankTransfer'" viewBox="0 0 24 24">
              <path
                d="M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z"
              ></path>
            </svg>

            <svg *ngIf="method.id === 'phone'" viewBox="0 0 24 24">
              <path
                d="M6.62 10.79a15.09 15.09 0 006.59 6.59l2.2-2.2a1 1 0 011.06-.24c1.12.45 2.33.69 3.53.69a1 1 0 011 1v3.5a1 1 0 01-1 1A17 17 0 013 5a1 1 0 011-1h3.5a1 1 0 011 1c0 1.21.23 2.41.69 3.53a1 1 0 01-.24 1.06l-2.33 2.2z"
              ></path>
            </svg>
          </div>
          <span class="method-name">{{ method.name }}</span>
        </div>
      </div>
    </div>

    <div class="form-group" style="margin-bottom: 16px">
      <div
        style="
          background: #f0f9ff;
          border: 1px solid #bfdbfe;
          border-radius: 8px;
          padding: 12px;
          font-size: 14px;
          color: #1e40af;
        "
      >
        <div style="display: flex; align-items: center; gap: 8px">
          <svg
            style="width: 16px; height: 16px; flex-shrink: 0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          <span
            >A PDF receipt will be automatically sent to your email after
            payment.</span
          >
        </div>
      </div>
    </div>

    <button
      type="submit"
      class="top-up-button"
      [disabled]="isSubmitting || topUpForm.invalid"
    >
      <span *ngIf="!isSubmitting">Add Funds</span>
      <div class="spinner" *ngIf="isSubmitting">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </button>
  </form>
</div>
